var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 34,
    viewBox: "0 0 15 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.665 31.977L3.21 17l9.457-14.977",
    stroke: "currentColor",
    strokeWidth: 4
  })));
}
export default __webpack_public_path__ + "media/icons/chevron-left-48c8ad78.svg";
export { SvgChevronLeft as ReactComponent };